/*
 * @deprecated instead use cssVar from primitives
 * */
export const cssVar = (str: string | undefined) => (str ? `var(${str})` : '');
